export default __webpack_public_path__ + "static/media/P1000-Tip.a993c930.svg";